import { t } from '../../i18n.es.js';

const reviewMock = {
  items: [
    {
      rating: 4,
      comment: t("ch\xE0 c\xE0 r\xF4n"),
      createdAt: "2020-04-24T03:38:33"
    }
  ],
  statisticVotes: { 1: 0, 2: 0, 3: 0, 4: 1, 5: 0 },
  average: 4,
  totalRating: 1
};

export { reviewMock };
